var _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCadminTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#395FD2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1245_137)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1756 36C29.9881 36 35.3542 27.9224 35.3542 20.9155C35.3542 20.6848 35.3482 20.457 35.3393 20.2293C36.381 19.481 37.2857 18.5463 38 17.4845C37.0446 17.9075 36.0149 18.1914 34.9375 18.3186C36.0387 17.662 36.8839 16.6238 37.2827 15.3875C36.253 15.9938 35.1101 16.4375 33.8958 16.6741C32.9226 15.6448 31.5357 15 30.003 15C27.0565 15 24.6667 17.3751 24.6667 20.3003C24.6667 20.7173 24.7143 21.1196 24.8065 21.51C20.372 21.2882 16.4405 19.1793 13.8125 15.9701C13.3542 16.7539 13.0893 17.6649 13.0893 18.6351C13.0893 20.4748 14.0298 22.0986 15.4643 23.048C14.5893 23.0214 13.7679 22.7818 13.0476 22.3855C13.0476 22.4062 13.0476 22.4299 13.0476 22.4535C13.0476 25.0208 14.8869 27.1652 17.3274 27.6503C16.878 27.7715 16.4077 27.8366 15.9226 27.8366C15.5804 27.8366 15.244 27.8041 14.9196 27.742C15.5982 29.8479 17.5685 31.38 19.9018 31.4244C18.0714 32.8441 15.7708 33.693 13.2738 33.693C12.8423 33.693 12.4196 33.6693 12 33.619C14.3601 35.1215 17.1637 36 20.1756 36Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1245_137"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 21,
    fill: "white",
    transform: "translate(12 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCadminTwitter);
export default __webpack_public_path__ + "static/media/CadminTwitter.c73f5622bc7d8dbcb62ce9ceb2fb0faa.svg";
export { ForwardRef as ReactComponent };